module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header clearfix"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t(_vm.$route.name)))]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-success",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Добави",
      "to": "/book/new"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [(_vm.dataReady) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "md-form form-sm"
  }, [_c('i', {
    staticClass: "fa fa-tag prefix"
  }), _vm._v(" "), _c('f-category', {
    attrs: {
      "cplaceholder": "Търсене по категория"
    },
    on: {
      "input": function($event) {
        _vm.fetchData()
      }
    },
    model: {
      value: (_vm.filter.categories),
      callback: function($$v) {
        _vm.$set(_vm.filter, "categories", $$v)
      },
      expression: "filter.categories"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "md-form form-sm"
  }, [_c('i', {
    staticClass: "fa fa-search prefix"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Търсене по заглавие, автор, издателство, описание"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.fetchData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "md-form form-sm"
  }, [_c('i', {
    staticClass: "fa fa-search prefix"
  }), _vm._v(" "), _c('f-family', {
    attrs: {
      "cplaceholder": "Търсене по семейство"
    },
    on: {
      "input": function($event) {
        _vm.fetchData()
      }
    },
    model: {
      value: (_vm.filter.family),
      callback: function($$v) {
        _vm.$set(_vm.filter, "family", $$v)
      },
      expression: "filter.family"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('f-select', {
    attrs: {
      "values": _vm.$config.lists.bookStatuses,
      "hide-name": true,
      "allow-none": "",
      "cplaceholder": "Търсене по статус"
    },
    on: {
      "input": function($event) {
        _vm.fetchData()
      }
    },
    model: {
      value: (_vm.filter.status),
      callback: function($$v) {
        _vm.$set(_vm.filter, "status", $$v)
      },
      expression: "filter.status"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('table', {
    staticClass: "table table-striped table-no-bordered table-hover table-responsive",
    attrs: {
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.records.items), function(item) {
    return _c('tr', {
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "vertical-middle"
    }, [_c('img', {
      staticStyle: {
        "width": "50px",
        "float": "left",
        "margin": "5px"
      },
      attrs: {
        "alt": "",
        "src": item.image || '/network/static/img/default_book.jpg'
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "vertical-middle"
    }, [_vm._v(_vm._s(item.title)), _c('br'), _vm._v(" "), _c('c-categories', {
      attrs: {
        "value": item.categories
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "vertical-middle"
    }, [_vm._v(_vm._s(item.author))]), _vm._v(" "), _c('td', {
      staticClass: "vertical-middle"
    }, [_vm._v(_vm._s(item.publisher))]), _vm._v(" "), _c('td', {
      staticClass: "vertical-middle"
    }, [_c('span', {
      class: 'tag badge badge-' + _vm.$config.lists.bookStatuses[item.status].style
    }, [_vm._v(_vm._s(_vm.$t('status.book_' + item.status)))])]), _vm._v(" "), _c('td', {
      staticClass: "vertical-middle"
    }, [_c('div', {
      staticClass: "text-center float-left"
    }, [(item.taker) ? _c('span', [_vm._v("на")]) : _vm._e(), _c('br'), _vm._v(" "), _c('c-avatar', {
      staticClass: "float-left",
      attrs: {
        "family": item.family
      }
    })], 1), _vm._v(" "), (item.taker) ? _c('div', {
      staticClass: "text-center float-left"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tпри"), _c('br'), _vm._v(" "), _c('c-avatar', {
      attrs: {
        "family": item.taker
      }
    }), _vm._v(" "), _c('br'), _vm._v("до"), _c('br'), _vm._v("  " + _vm._s(_vm._f("prettyDate")(item.takerDueDate)) + "\n\t\t\t\t\t\t\t\t\t\t")], 1) : _vm._e(), _vm._v(" "), (item.takerExternal) ? _c('div', {
      staticClass: "text-center float-left",
      staticStyle: {
        "max-width": "100px"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tпри"), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t[" + _vm._s(item.takerExternal) + "]\n\t\t\t\t\t\t\t\t\t\t\t"), _c('br'), _vm._v("до"), _c('br'), _vm._v("  " + _vm._s(_vm._f("prettyDate")(item.takerDueDate)) + "\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "vertical-middle text-right text-nowrap"
    }, [_c('router-link', {
      staticClass: "btn btn-small btn-primary btn-icon",
      attrs: {
        "to": '/book/' + item.id
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    })]), _vm._v(" "), (_vm.canEdit(item)) ? [_c('router-link', {
      staticClass: "btn btn-small btn-warning btn-icon",
      attrs: {
        "to": '/book/' + item.id + '/edit'
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-small btn-danger btn-icon m-0",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.remove(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-remove"
    })])] : _vm._e()], 2)])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('f-pager', {
    attrs: {
      "total": _vm.records.total,
      "clickhandler": _vm.pageClick
    }
  })], 1)])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "60px"
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "sorting_asc",
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v("Заглавие")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v("Автор")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v("Издателство")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v("Статус")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v("Семейство")]), _vm._v(" "), _c('th', {
    staticClass: "disabled-sorting text-right sorting",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v("Действие")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-accb890a!./~/vue-loader/lib/selector.js?type=template&index=0!./~/htmlhint-loader?{"configFile":".htmlhintrc.json","failOnError":true}!./src/components/share/Books.vue
// module id = 667
// module chunks = 1